/**
 * Nutrapel — Auto Peroxido
 * -------------------------
 * Cuando un producto con product_type "Tinte Permanente" se agrega al carrito,
 * agrega automáticamente el Platinoxide en la misma cantidad.
 *
 * SOLO opera en retail (B2C). En contexto B2B se desactiva solo,
 * porque el Platinoxide no está en el catálogo B2B.
 */

(function () {
  'use strict';

  // ─── GUARDA B2B: si es contexto B2B, no hacer nada ──────────────────────────
  function isB2BContext() {
    try {
      // Shopify expone la compañía B2B aquí cuando hay un cliente B2B activo
      if (window.Shopify && window.Shopify.company && window.Shopify.company.id) return true;
      // Algunos temas/checkout exponen el catálogo de compañía
      if (window.Shopify && window.Shopify.companyLocationId) return true;
      return false;
    } catch (e) {
      return false;
    }
  }

  if (isB2BContext()) {
    console.log('[Nutrapel] Contexto B2B detectado — Auto Peroxido desactivado.');
    return; // corta todo aquí, el script no se inicializa
  }

  // ─── CONFIGURACIÓN ────────────────────────────────────────────────────────
  const TRIGGER_TYPES       = ['Tinte Permanente', 'Tinte Permanente Sin Amoniaco'];
  const PEROXIDO_HANDLE     = 'platinoxide-20-vol';
  const PEROXIDO_VARIANT_ID = 41800386576446;
  // ──────────────────────────────────────────────────────────────────────────

  let variantId    = PEROXIDO_VARIANT_ID;
  let isProcessing = false;
  let selfRequest  = false;

  const isCartPage = window.location.pathname === '/cart';

  // ─── HELPERS ──────────────────────────────────────────────────────────────

  async function fetchCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  function getTintesQuantity(items) {
    return items
      .filter(item => TRIGGER_TYPES.includes(item.product_type))
      .reduce((sum, item) => sum + item.quantity, 0);
  }

  function getPeroxidoItem(items) {
    return items.find(item => item.variant_id === variantId) || null;
  }

  async function cartChange(id, quantity) {
    selfRequest = true;
    const res = await fetch('/cart/change.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ id, quantity }),
    });
    setTimeout(() => { selfRequest = false; }, 300);
    if (!res.ok) throw new Error(`[Nutrapel] cart/change.js falló: ${res.status}`);
    return res.json();
  }

  async function cartAdd(varId, quantity) {
    selfRequest = true;
    const res = await fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({
        id:         varId,
        quantity:   quantity,
        properties: { _auto_added: 'peroxido' },
      }),
    });
    setTimeout(() => { selfRequest = false; }, 300);
    if (!res.ok) throw new Error(`[Nutrapel] cart/add.js falló: ${res.status}`);
    return res.json();
  }

  async function notifyTheme() {
    if (isCartPage) {
      window.location.reload();
      return;
    }

    try {
      const sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
      );

      const sectionsParam = sectionsToBundle.join(',');
      const res = await fetch(`${window.Shopify.routes.root}cart.js`);
      const cartData = await res.json();

      if (sectionsParam) {
        const secRes = await fetch(`${window.Shopify.routes.root}?sections=${encodeURIComponent(sectionsParam)}`);
        const secJson = await secRes.json();
        cartData.sections = secJson;
      }

      if (window.FoxTheme?.pubsub?.publish) {
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartData });
      }
    } catch (err) {
      console.error('[Nutrapel] notifyTheme falló:', err);
    }
  }

  // ─── LÓGICA PRINCIPAL ─────────────────────────────────────────────────────

  async function syncPeroxido() {
    if (isProcessing) return;
    isProcessing = true;

    try {
      const cart      = await fetchCart();
      const tintesQty = getTintesQuantity(cart.items);
      const peroxItem = getPeroxidoItem(cart.items);
      const peroxQty  = peroxItem ? peroxItem.quantity : 0;

      if (tintesQty === peroxQty) return;

      if (tintesQty === 0 && peroxQty > 0) {
        await cartChange(peroxItem.key, 0);
        notifyTheme();
        return;
      }

      if (tintesQty > 0 && peroxQty === 0) {
        await cartAdd(variantId, tintesQty);
        notifyTheme();
        return;
      }

      if (tintesQty > 0 && peroxQty !== tintesQty) {
        await cartChange(peroxItem.key, tintesQty);
        notifyTheme();
      }

    } catch (err) {
      console.error('[Nutrapel] Error al sincronizar Platinoxide:', err);
    } finally {
      isProcessing = false;
    }
  }

  // ─── INTERCEPTOR DE FETCH ─────────────────────────────────────────────────

  function interceptCartRequests() {
    const originalFetch = window.fetch;

    window.fetch = async function (...args) {
      const response = await originalFetch.apply(this, args);

      const url = typeof args[0] === 'string'
        ? args[0]
        : (args[0]?.url || '');

      const isCartMutation =
        url.includes('/cart/add') ||
        url.includes('/cart/change') ||
        url.includes('/cart/update') ||
        url.includes('/cart/clear');

      if (isCartMutation && !selfRequest) {
        setTimeout(syncPeroxido, 150);
      }

      return response;
    };
  }

  // ─── EVENTOS DEL TEMA ─────────────────────────────────────────────────────

  function listenToThemeEvents() {
    const events = ['cart:item-added', 'cart:item-removed', 'cart:item-updated'];
    events.forEach(evt => {
      document.addEventListener(evt, () => { if (!selfRequest) setTimeout(syncPeroxido, 150); });
    });
  }

  // ─── OBTENER VARIANT ID (con fallback) ────────────────────────────────────

  async function resolveVariantId() {
    try {
      const res = await fetch(`/products/${PEROXIDO_HANDLE}.js`);
      if (!res.ok) throw new Error('Producto no encontrado');
      const product = await res.json();
      const variant = product.variants.find(v => v.available) || product.variants[0];
      if (variant?.id) {
        variantId = variant.id;
      }
    } catch (err) {
      console.warn('[Nutrapel] Handle no encontrado, usando variant ID fijo:', variantId);
    }
  }

  // ─── INIT ─────────────────────────────────────────────────────────────────

  async function init() {
    await resolveVariantId();
    interceptCartRequests();
    listenToThemeEvents();
    await syncPeroxido();
    console.log('[Nutrapel] Auto Peroxido activo (retail). Variant ID:', variantId);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();